import cx from "classnames";
import Image from "next/image";
const CategoryBottomBanner = ({
  bottomDesktopBanners,
  bottomMobileBanners,
  categoryName
}) => {
  if (bottomDesktopBanners.length === 0 && bottomMobileBanners.length === 0) return;
  return <div className="w-full pb-4" data-sentry-component="CategoryBottomBanner" data-sentry-source-file="CategoryBottomBanner.jsx">
      {bottomDesktopBanners?.map(banner => <>
          <Image src={banner?.imageURI} key={banner?.id} width={banner?.width} height={banner?.height} className={cx("mx-auto", {
        "hidden sm:block": banner?.imageType === "BOTTOM_DESKTOP"
      })} alt={categoryName} />
        </>)}
      {bottomMobileBanners?.map(banner => <>
          <Image src={banner?.imageURI} width={banner?.width} height={banner?.height} className={cx("mx-auto", {
        "sm:hidden": banner?.imageType === "BOTTOM_MOBILE"
      })} key={banner?.id} alt={categoryName} />
        </>)}
    </div>;
};
export default CategoryBottomBanner;